import { URLS } from '../../../constants';
import apiClient from '../../client';

export const getInProgressLongTermApi = {
  getLongTermGoal: ({
    providerId,
    clientId,
    childPayerId,
  }: {
    providerId: string;
    clientId: string;
    childPayerId: any;
  }) =>
    apiClient.post(URLS.getInProgressLongTerm, {
      data: {
        providerId,
        clientId,
        childPayerId,
      },
    }),
};
export const getInProgressShortTermApi = {
  getShortTermGoal: ({
    providerId,
    clientId,
    childPayerId,
  }: {
    providerId: string;
    clientId: string;
    childPayerId?: any;
  }) =>
    apiClient.post(URLS.getInProgressShortTerm, {
      data: {
        providerId,
        clientId,
        childPayerId,
      },
    }),
};
export const getInterventionInProgressLongTermApi = {
  getLongTermGoal: ({
    clientId,
    organizationServiceId,
  }: {
    clientId: string;
    organizationServiceId: any;
  }) =>
    apiClient.post(URLS.getIntervesntionInProgressLongTerm, {
      data: {
        organizationServiceId,
        clientId,
      },
    }),
};
export const getInterventionInProgressShortTermApi = {
  getShortTermGoal: ({
    clientId,
    organizationServiceId,
  }: {
    clientId: string;
    organizationServiceId: any;
  }) =>
    apiClient.post(URLS.getIntervesntionInProgressShortTerm, {
      data: {
        organizationServiceId,
        clientId,
      },
    }),
};
